/**
 * Whether a status reads as a pass, a fail, or neither (e.g. "PENDING").
 *
 * The API uses two vocabularies for the same idea — documents and applicants
 * come back "valid"/"invalid", checks "passed"/"failed" — in whatever casing,
 * so every consumer that wants to colour or icon a status normalizes here
 * rather than repeating the comparison.
 */
export type VerificationOutcome = "pass" | "fail" | "unknown";

const PASS_STATUSES = ["valid", "passed"];
const FAIL_STATUSES = ["invalid", "failed"];

export function getStatusOutcome(status: string): VerificationOutcome {
  const normalized = status.trim().toLowerCase();
  if (PASS_STATUSES.includes(normalized)) return "pass";
  if (FAIL_STATUSES.includes(normalized)) return "fail";
  return "unknown";
}
